import React, {useState} from 'react';
import {Field, withFormik} from "formik";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import {connect} from "react-redux";
import MaterialTextField from "../../../comun/Forms/MaterialTextField";
import {Grid} from "../../../comun/Grid/Grid";


export let ZoneFilters = ({zone, handleSubmit, manage=false, ...props}) => {
    
    return(
        <React.Fragment>
            <form className="form-filters" onSubmit={handleSubmit}>
                <h3>Filtros</h3>
                <Grid columns="1fr" mobileColumns="1fr">
                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="name"
                           variant="outlined" label="Nombre" />

                    <Button  variant="contained" className="form-control-child-input-height" color="secondary" type="submit">Filtrar</Button>
                </Grid>

            </form>
        </React.Fragment>
    )
}

const schema = Yup.object().shape({
    name: Yup.string(),
});

ZoneFilters = withFormik(
    {
        validationSchema: schema,
        mapPropsToValues: (props) => {
            return {
                name: ''
            }
        },
        handleSubmit: async (vals, props) => {
            const data = Object.assign({}, vals);
            props.setSubmitting(false);
            props.props.onSubmit(data);
        },
        displayName: 'Filtrar Zonas',
    }
)(ZoneFilters);
const mapPropsToState = state => {
    return {
        zone: state.zone
    }
}

ZoneFilters = connect(mapPropsToState, null)(ZoneFilters);
